export default {
  header:{
    title: 'Votre réservation',
    btnMap: {
      show:'Montrer la carte',
      hide:'Masquer la carte',
    },
  },
  seat: '{{seat}} Siège',
  seats: '{{seats}} Sièges',
  total: 'Total',
  btnPayment: {
    precced: 'Réserver',
    pay: 'Confirmer la réservation',
  },
  dropoffTime: '(Heure d\'arrivée)',
};